import { compose } from 'lodash/fp';
import api from '../../../api';
import PageHeader from '../../components/PageHeader';
import PageTitle from '../../components/PageTitle';
import { withAppContext } from '../../hoc/withAppContext';
import { withPageData } from '../../hoc/withPageData';
import AdminOverview from '../Admin/Overview/presenter';
import { countAdminErrors, groupLinksByCategory } from '../Admin/Overview/service';

function IntegrationsPage({ adminLinks, appContext }) {
    const title = 'Integrations';
    return (
        <>
            <PageTitle title={title} />
            <PageHeader title={title}></PageHeader>
            <AdminOverview
                categories={groupLinksByCategory(adminLinks)}
                errorCount={countAdminErrors(adminLinks)}
                currentUser={appContext.user}
            />
        </>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () => api.admin.getIntegrationsLinks(),
        },
    }),
    withAppContext
)(IntegrationsPage);
